<template>
    <div class="row">
        <div v-for="object in fetchedData" class="col-6">
            <slot name="gridRepresentationCard" v-bind="object"></slot>
        </div>
    </div>
</template>


<script>

  export default {

      props: {
            sortBy: {
                type: String,
                default: "uid",
                required: false,
            },
            isSortDirDesc: {
                type: Boolean,
                default: true,
                required: false,
            },
            fetchedData: {
                type: Array,
                default: () => [],
                required: false,
            },
            dataLoading: {
                type: Boolean,
                default: false,
                required: false,
            },

      },

  }
</script>
